import { ref } from 'vue';
import { $api } from '@/services';

const error = ref(null);
const loading = ref(false);

export async function getOrg() {
	error.value = null;
	try {
		const res = await $api.org.getOrg();
		return res?.data;
	} catch (err) {
		error.value = err?.response?.data?.errors || err.message;
	} finally {
		loading.value = false;
	}
}

export function useGetOrg() {
	return { error, loading, getOrg };
}
